import React, { Component } from 'react';
import { obterTermosAtivosPorProduto } from '../../servicos/termosApi';
import { obterParametrosDaUrl } from '../../helpers/parametrosDeUrl';
import { Header, Footer } from '../../componentes'
import EstadoVazio from '@bit/digix.digixui.estado-vazio';
import Carregamento from '@bit/digix.digixui.carregamento';

class VisualizacaoDeTermos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deveExibirCarregamento: true,
      termosDoProduto: [],
      estadoVazio: {
        mensagem: 'Termos do produto',
        descricao: "No momento não existem termos ativos. Quando existir um termo para este produto, você conseguirá consultar ele por aqui.",
        icone: 'far fa-file-alt',
        cor: ''
      }
    };
  }
  componentDidMount() {
    let { produto } = obterParametrosDaUrl(this.props.location.search);

    obterTermosAtivosPorProduto(produto, 'TermoDeUso')
      .then((termosDoProduto) => {
        this.setState({
          produto, termosDoProduto,
          deveExibirCarregamento: false
        });
      }).catch(() => {
        this.setState({
          estadoVazio: {
            mensagem: 'Identificamos um erro',
            descricao: 'Não foi possível obter os termos do produto por conta de um erro interno. Recarregue a página (F5) e caso o problema persista, entre em contato com o suporte',
            icone: 'far fa-times-circle',
            cor: 'erro'
          },
          deveExibirCarregamento: false
        });
      });
  }

  render() {
    let { deveExibirCarregamento, termosDoProduto, estadoVazio } = this.state;

    return (
      <React.Fragment>
        <Header />
        {deveExibirCarregamento &&
          <Carregamento
            tamanho='grande'
            altura='grande'
            telaCheia={true} />}
        {termosDoProduto[0] ?
          <React.Fragment>
            {termosDoProduto.map(politica => <div dangerouslySetInnerHTML={{ __html: politica.conteudo }}></div>)}
          </React.Fragment>
          : !deveExibirCarregamento &&
          <EstadoVazio
            icone={estadoVazio.icone}
            mensagem={estadoVazio.mensagem}
            descricao={estadoVazio.descricao}
            cor={estadoVazio.cor}
            altura="medio"
            largura="medio" />}
        <Footer />
      </React.Fragment>
    );
  }
}

export default VisualizacaoDeTermos;